import {
  scratch,
  web,
  python,
  full,
  vibe,
  back,
  seo,
  wordpress,
  machine,
} from "./images";

export const courses = [
  {
    id: 1,
    title: "Search & Visibility Optimization for Modern Businesses",
    price: "KSH 5,000",
    category: "d_m",
    course_img: seo,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: Entrepreneurs, Brands & Professionals" },
        { icon: "fas fa-chalkboard-teacher", title: "SEO, visibility & digital growth strategy" },
        { icon: "fas fa-clock", title: "Increase discoverability and reach" },
        { icon: "fas fa-tasks", title: "Key Skills: Search optimization & brand visibility" },
      ],
    },
    description: {
      course_desc:
        "Learn how to improve your online visibility, attract the right audience, and turn search traffic into measurable business growth.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Business owners and startup founders",
          "Professionals building digital presence",
          "Teams looking to grow and convert online traffic",
        ],
      },
      syllabus: [
        {
          title: "Module 1: SEO Foundations",
          body: "This module introduces how search engines work, the role of keywords, and how businesses can improve visibility in crowded digital markets. Learners will study search intent, content targeting, and simple optimization techniques that support growth and discoverability.",
        },
        {
          title: "Module 2: On-Page Optimization",
          body: "Participants learn how to improve website structure, metadata, headings, page copy, and internal linking. The focus is on making pages easier for search engines to understand while also creating a clear and engaging experience for users.",
        },
        {
          title: "Module 3: Visibility Strategy",
          body: "This module connects search learning to business outcomes. Students learn how to build a content and visibility plan that attracts the right audience, strengthens brand awareness, and increases the likelihood of conversions and customer retention.",
        },
      ],
    },
  },
  {
    id: 2,
    title: "Vibe Coding (No-Code Software Development)",
    price: "KSH 5,000",
    category: "web",
    course_img: vibe,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: Beginners, Creators & Career Changers" },
        { icon: "fas fa-chalkboard-teacher", title: "Build software without writing complex code" },
        { icon: "fas fa-clock", title: "Rapid prototyping with modern tools" },
        { icon: "fas fa-tasks", title: "Key Skills: Workflow design, automation & product thinking" },
      ],
    },
    description: {
      course_desc:
        "Create digital solutions using no-code platforms and discovery-driven workflows to build tools, automations, and apps faster.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Creative thinkers and problem solvers",
          "Students and professionals exploring software design",
          "Anyone wanting to build without heavy coding",
        ],
      },
      syllabus: [
        {
          title: "Module 1: Product Thinking",
          body: "This module teaches learners how to define a real problem, identify the right user needs, and turn an idea into a simple product concept. Students develop practical thinking skills that help them design useful software without needing deep technical knowledge.",
        },
        {
          title: "Module 2: Workflow Automation",
          body: "Learners explore no-code tools for automating tasks, organizing data, and linking different systems together. The module covers practical triggers, workflows, dashboards, and process mapping for personal productivity and business operations.",
        },
        {
          title: "Module 3: Prototype Build",
          body: "Students apply their ideas by building a first working prototype or workflow. The module emphasizes testing, feedback, refining features, and turning a concept into a simple digital solution that can be used or presented to others.",
        },
      ],
    },
  },
  {
    id: 3,
    title: "Python Programming Fundamentals with AI",
    price: "KSH 5,000",
    category: "kids",
    course_img: python,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: Teens & Beginners" },
        { icon: "fas fa-chalkboard-teacher", title: "Python syntax, logic & AI-assisted learning" },
        { icon: "fas fa-clock", title: "Step-by-step software thinking" },
        { icon: "fas fa-tasks", title: "Key Skills: Data structures, logic & AI prompt use" },
      ],
    },
    description: {
      course_desc:
        "Learn Python fundamentals in a practical way while using AI tools to support coding, problem-solving, and project-building.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Teens and beginners",
          "Students starting a programming journey",
          "Anyone interested in AI-powered learning",
        ],
      },
      syllabus: [
        {
          title: "Module 1: Python Basics",
          body: "Learners are introduced to Python syntax, variables, operators, functions, and the flow of a simple program. This gives them the confidence to write their own small scripts and begin understanding how software follows logic and instructions.",
        },
        {
          title: "Module 2: Logic and Problem Solving",
          body: "This module focuses on decision-making, loops, conditions, and algorithmic thinking. Students build their problem-solving skills through practical coding exercises that encourage pattern recognition and structured reasoning.",
        },
        {
          title: "Module 3: AI-Assisted Coding",
          body: "Students learn how to use AI tools alongside Python to brainstorm solutions, test code, explain errors, and deepen understanding. This makes learning more interactive, visual, and accessible for beginners who want to learn with modern digital support.",
        },
      ],
    },
  },
  {
    id: 4,
    title: "Scratch Programming & Logic",
    price: "KSH 5,000",
    category: "kids",
    course_img: scratch,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: Juniors (Ages 7–12)" },
        { icon: "fas fa-chalkboard-teacher", title: "Creative coding with games & animations" },
        { icon: "fas fa-clock", title: "Build computational thinking" },
        { icon: "fas fa-tasks", title: "Key Skills: Algorithms & problem-solving" },
      ],
    },
    description: {
      course_desc:
        "Build a strong foundation in logical thinking by creating interactive stories, games, and animations with Scratch.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Juniors (Ages 7–12)",
          "Young learners exploring coding",
          "Beginners who enjoy creating digital projects",
        ],
      },
      syllabus: [
        {
          title: "Module 1: Code Blocks",
          body: "Students learn how the Scratch interface works, including sprites, backdrops, scripts, and event-based actions. This helps them understand that coding is simply a structured way to give instructions to a program.",
        },
        {
          title: "Module 2: Logic and Sequences",
          body: "This module introduces sequence, loops, conditions, and problem-solving through interactive projects such as games and animated stories. Learners begin to build the thinking patterns behind computational logic and creativity.",
        },
        {
          title: "Module 3: Creative Coding",
          body: "Children create their own scenes, characters, and interactive interactions by combining design and logic. The goal is to encourage imagination while reinforcing key coding concepts in a playful and engaging way.",
        },
      ],
    },
  },
  {
    id: 5,
    title: "Web Fundamentals for kids and teens",
    price: "KSH 5,000",
    category: "kids",
    course_img: web,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: Teens & Young Learners" },
        { icon: "fas fa-chalkboard-teacher", title: "Introduction to HTML, CSS & web structure" },
        { icon: "fas fa-clock", title: "Learn the foundation of digital design" },
        { icon: "fas fa-tasks", title: "Key Skills: Web pages, layout & simple interfaces" },
      ],
    },
    description: {
      course_desc:
        "Discover how the internet works and build your first websites with the essential building blocks of modern web creation.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Teens and young learners",
          "Students exploring digital skills",
          "Beginners curious about web design and development",
        ],
      },
      syllabus: [
        {
          title: "Module 1: Web Basics",
          body: "Learners are introduced to how websites function, what browsers do, and how content travels across the internet. This gives them a strong foundation for understanding digital communication and online user experiences.",
        },
        {
          title: "Module 2: HTML Fundamentals",
          body: "This module focuses on page structure using headings, paragraphs, links, lists, images, and forms. Students learn how to organize content clearly so that a webpage communicates information effectively.",
        },
        {
          title: "Module 3: CSS Essentials",
          body: "Students learn how to style pages using colors, spacing, layout, typography, and alignment. This allows them to transform basic content into visually appealing and easy-to-use web pages.",
        },
      ],
    },
  },
  {
    id: 6,
    title: "Full Stack Development",
    price: "KSH 5,000",
    category: "web",
    course_img: full,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: Career Switchers & Developers" },
        { icon: "fas fa-chalkboard-teacher", title: "Build complete digital products from end to end" },
        { icon: "fas fa-clock", title: "Frontend + backend + deployment workflow" },
        { icon: "fas fa-tasks", title: "Key Skills: APIs, databases, logic & interfaces" },
      ],
    },
    description: {
      course_desc:
        "Master both the visual and server-side layers of web applications and build complete, production-ready software projects.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Aspiring full stack developers",
          "Career switchers in tech",
          "Builders creating complete web products",
        ],
      },
      syllabus: [
        {
          title: "Module 1: Frontend Essentials",
          body: "Students build the visual layer of web applications using HTML, CSS, JavaScript, and responsive layouts. This module introduces the principles of user-friendly design and interactive pages.",
        },
        {
          title: "Module 2: Backend Development",
          body: "Learners explore the logic behind applications by working with APIs, server-side processing, and database interactions. They understand how the frontend connects with data and business operations.",
        },
        {
          title: "Module 3: Full Product Build",
          body: "This final module combines both sides of development as students build a real project from planning to deployment. The goal is to create a practical digital product that demonstrates full-stack thinking and problem solving.",
        },
      ],
    },
  },
  {
    id: 7,
    title: "Frontend Development",
    price: "KSH 5,000",
    category: "web",
    course_img: web,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: UI Designers & Web Enthusiasts" },
        { icon: "fas fa-chalkboard-teacher", title: "Build interactive interfaces and responsive pages" },
        { icon: "fas fa-clock", title: "Modern frontend design and user experience" },
        { icon: "fas fa-tasks", title: "Key Skills: HTML, CSS, JavaScript & UI/UX" },
      ],
    },
    description: {
      course_desc:
        "Learn how to craft polished, responsive, and user-friendly interfaces that work across devices and modern browsers.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Designers moving into code",
          "Students exploring frontend careers",
          "Anyone passionate about building engaging user experiences",
        ],
      },
      syllabus: [
        {
          title: "Module 1: Responsive UI Design",
          body: "This module shows learners how to build interfaces that adapt across devices and remain easy to read and navigate. Emphasis is placed on layout, spacing, hierarchy, and mobile-first design.",
        },
        {
          title: "Module 2: Interactive Frontend",
          body: "Students learn how JavaScript controls user interactions, animations, validation, and dynamic page updates. They build practical skills for creating engaging and functional interfaces.",
        },
        {
          title: "Module 3: Frontend Deployment",
          body: "The final module teaches learners how to prepare a website or application for launch, test it properly, and share it with users. This includes a practical understanding of publishing and live deployment workflows.",
        },
      ],
    },
  },
  {
    id: 8,
    title: "Backend Development",
    price: "KSH 5,000",
    category: "web",
    course_img: back,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: Developers & Tech Career Seekers" },
        { icon: "fas fa-chalkboard-teacher", title: "Build server-side logic and data flows" },
        { icon: "fas fa-clock", title: "Understand systems that power web apps" },
        { icon: "fas fa-tasks", title: "Key Skills: APIs, databases, auth & architecture" },
      ],
    },
    description: {
      course_desc:
        "Develop the hidden logic behind digital products by learning how servers, applications, and data connect to form working systems.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Developers who want deeper technical skills",
          "Career changers entering software engineering",
          "Builders creating scalable digital systems",
        ],
      },
      syllabus: [
        {
          title: "Module 1: Server-Side Fundamentals",
          body: "Learners study how applications receive requests, process data, and return responses. This helps them understand the system logic behind websites, apps, and digital services.",
        },
        {
          title: "Module 2: Databases and APIs",
          body: "This module covers data storage, API design, and communication between applications and databases. Students learn how information moves securely and efficiently between systems.",
        },
        {
          title: "Module 3: System Design Basics",
          body: "Students are introduced to authentication, scalability, and application architecture principles. They learn how to think beyond code and consider maintainable, secure, and practical software design.",
        },
      ],
    },
  },
  {
    id: 9,
    title: "WordPress - Free",
    price: "Free",
    category: "web",
    course_img: wordpress,
    details: {
      price_new: "Free",
      features: [
        { icon: "fas fa-business-time", title: "Format: Flexible Online Learning" },
        { icon: "fas fa-calendar-week", title: "Target: Beginners & Business Owners" },
        { icon: "fas fa-chalkboard-teacher", title: "Create websites with WordPress and plugins" },
        { icon: "fas fa-clock", title: "Build fast with a friendly CMS" },
        { icon: "fas fa-tasks", title: "Key Skills: Pages, content, themes & publishing" },
      ],
    },
    description: {
      course_desc:
        "Learn how to build and manage a professional website using WordPress, one of the easiest and most widely used content management systems.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Small business owners",
          "Bloggers and content creators",
          "Beginner website builders",
        ],
      },
      syllabus: [
        {
          title: "Module 1: WordPress Setup",
          body: "Learners are guided through installation, dashboard navigation, and basic configuration for a working WordPress site. This module builds the foundation for launching a simple online presence.",
        },
        {
          title: "Module 2: Themes and Design",
          body: "Students customize the look and feel of their website using themes, branding, layouts, and styling. The focus is on creating a clean and professional online identity.",
        },
        {
          title: "Module 3: Content and Plugins",
          body: "This module introduces pages, posts, plugins, and essential features that turn a basic website into a functional publishing platform. Learners also understand how to manage updates and improve site performance.",
        },
      ],
    },
  },
 
  {
    id: 11,
    title: "Machine Learning Fundamentals",
    price: "KSH 5,000",
    category: "web",
    course_img: machine,
    details: {
      price_new: "KSH 5,000",
      features: [
        { icon: "fas fa-business-time", title: "Format: Evening Online | Weekend Bootcamp (3 Hrs)" },
        { icon: "fas fa-calendar-week", title: "Target: Tech Learners & Problem Solvers" },
        { icon: "fas fa-chalkboard-teacher", title: "Understand data, models & AI patterns" },
        { icon: "fas fa-clock", title: "Explore the basics of intelligent systems" },
        { icon: "fas fa-tasks", title: "Key Skills: Data handling, prediction & model thinking" },
      ],
    },
    description: {
      course_desc:
        "Explore the foundations of machine learning and learn how data-driven models make predictions, classify patterns, and support intelligent systems.",
      course_info: {
        question: "Who this course is for",
        answer: [
          "Tech learners and students",
          "Professionals interested in AI",
          "Builders wanting to understand modern intelligence systems",
        ],
      },
      syllabus: [
        {
          title: "Module 1: Machine Learning Basics",
          body: "Learners explore the idea of machine learning, how algorithms learn from patterns, and how models are trained using examples. This module builds conceptual clarity before moving into practical tasks.",
        },
        {
          title: "Module 2: Data and Features",
          body: "Students investigate data quality, features, labels, and the relationship between input data and model predictions. The focus is on understanding why strong data is critical to successful AI systems.",
        },
        {
          title: "Module 3: Practical AI Thinking",
          body: "This module introduces classification, prediction, and problem-solving using real-world examples. Learners develop critical thinking around when AI is useful, how it works, and what makes a model effective.",
        },
      ],
    },
  },
];